export const WeatherTerminalAlphaSorting = function (
  data
) {
  data.sort(function (a, b) {
    if (a.terminal.terminalName.trim().toLowerCase() < b.terminal.terminalName.trim().toLowerCase()) { return -1; }
    if (a.terminal.terminalName.trim().toLowerCase() > b.terminal.terminalName.trim().toLowerCase()) { return 1; }
    return 0;
  });
  return data;
};
export const PortAlphaSorting = function (
  data
) {
  data.sort(function (a, b) {
    if (a.portName.trim().toLowerCase() < b.portName.trim().toLowerCase()) { return -1; }
    if (a.portName.trim().toLowerCase() > b.portName.trim().toLowerCase()) { return 1; }
    return 0;
  });
  return data;
};
export const ContainerSourceAlphaAscendingSorting = function (
  data
) {
  data.sort(function (a, b) {
    if (a.source.trim().toLowerCase() < b.source.trim().toLowerCase()) { return -1; }
    if (a.source.trim().toLowerCase() > b.source.trim().toLowerCase()) { return 1; }
    return 0;
  });
  return data;
};
export const ContainerSourceAlphaDescendingSorting = function (
  data
) {
  data.sort(function (a, b) {
    if (a.source.trim().toLowerCase() > b.source.trim().toLowerCase()) { return -1; }
    if (a.source.trim().toLowerCase() < b.source.trim().toLowerCase()) { return 1; }
    return 0;
  });
  return data;
};
export const ContainerDestinationAlphaAscendingSorting = function (
  data
) {
  data.sort(function (a, b) {
    if (a.destination.trim().toLowerCase() < b.destination.trim().toLowerCase()) { return -1; }
    if (a.destination.trim().toLowerCase() > b.destination.trim().toLowerCase()) { return 1; }
    return 0;
  });
  return data;
};
export const ContainerDestinationAlphaDescendingSorting = function (
  data
) {
  data.sort(function (a, b) {
    if (a.destination.trim().toLowerCase() > b.destination.trim().toLowerCase()) { return -1; }
    if (a.destination.trim().toLowerCase() < b.destination.trim().toLowerCase()) { return 1; }
    return 0;
  });
  return data;
};
export const ContainerStatusAlphaAscendingSorting = function (
  data
) {
  data.sort(function (a, b) {
    if (a.status.trim().toLowerCase() < b.status.trim().toLowerCase()) { return -1; }
    if (a.status.trim().toLowerCase() > b.status.trim().toLowerCase()) { return 1; }
    return 0;
  });
  return data;
};
export const ContainerStatusAlphaDescendingSorting = function (
  data
) {
  data.sort(function (a, b) {
    if (a.status.trim().toLowerCase() > b.status.trim().toLowerCase()) { return -1; }
    if (a.status.trim().toLowerCase() < b.status.trim().toLowerCase()) { return 1; }
    return 0;
  });
  return data;
};
